import { render } from "./ViewQcmStatsStudents.vue?vue&type=template&id=42b4d8ce&scoped=true"
import script from "./ViewQcmStatsStudents.vue?vue&type=script&lang=js"
export * from "./ViewQcmStatsStudents.vue?vue&type=script&lang=js"

import "./ViewQcmStatsStudents.vue?vue&type=style&index=0&id=42b4d8ce&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b4d8ce"]])

export default __exports__